/**
 * Standard Storefront Event : `PageViewEvent`.
 *
 * Alimente le Web Pixels Manager de Shopify, donc les rapports natifs de
 * l'admin. Lit `main[data-template]`, pose par `layout/theme.liquid`.
 *
 * Modele : shopify-theme-horizon/assets/page-view-event.js
 */
import { PageViewEvent } from '@shopify/events';
import { isDesignMode, onReady } from '@theme/standard-events-utils';

onReady(function dispatchPageView() {
  // Dans l'editeur de theme, chaque apercu enverrait un faux page_view.
  if (isDesignMode()) return;

  try {
    const main = document.querySelector('main[data-template]');

    document.dispatchEvent(
      new PageViewEvent({
        page: {
          template: (main && main.dataset.template) || '',
          title: document.title,
          url: window.location.href,
        },
      })
    );
  } catch (error) {
    // Un evenement de mesure ne doit jamais empecher la page de fonctionner.
  }
});
